<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            其他退款记录
        </div>
        <div style="padding: 20px;">
            <div>
                <div style="float:right">
                    <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable @change="getList(true)" style="margin:0 10px;width:200px"></el-input>
                    <el-select v-model="refundType" placeholder="选择退款类型" style="margin:0 10px;" >
                        <el-option
                                v-for="item in refundTypeValue"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                </div>
                <div style="clear: both;"></div>
            </div>
            <div style="height: 10px;"></div>
            <div>
                <el-table ref="historicalFilesTable" :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">
                    <el-table-column prop="elderlyName" label="姓名"></el-table-column>

                    <el-table-column prop="idCard" label="身份证"></el-table-column>

                    <el-table-column prop="returnBalance"  label="退费总额（元）"></el-table-column>

                    <el-table-column prop="refundType"  label="退款类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.refundType==1">现金退款</span>
                            <span v-if="scope.row.refundType==2">余额充值</span>
                            <span v-if="scope.row.refundType==3">支付宝退款</span>
                            <span v-if="scope.row.refundType==4">微信退款</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="remarks"  label="备注"></el-table-column>

                    <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="退费时间"></el-table-column>
                    
                </el-table>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "OtherPage",
        data() {
            return {
                elderlyName:'',
                bodyStyle:"height:"+(this.$store.state.tableHeight+150)+'px',
                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                loading:false,
                loadingInfo:false,
                th:this.$store.state.tableHeight,
                infoData:[],
                checkinDialog:false,
                refundTypeValue:[{
                    value: -1,
                    label: '全部退款类型'
                    }, {
                    value: 1,
                    label: '现金退款'
                    }, {
                    value: 2,
                    label: '充值余额'
                }],
                refundType:-1
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+150)+'px';
                this.th=val
            },
        },
        created(){
            this.getList();
        },
        methods: {
            init(){
                this.getList();
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"OtherRefundRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        refundType:this.refundType,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.$nextTick(()=>{
                            this.$refs.historicalFilesTable.doLayout()
                        })
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style lang='scss' scoped>

/deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }

</style>
